<script setup>
import { computed } from 'vue'
import { PaginationEllipsis } from 'radix-vue'
import { MoreHorizontal } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
})

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})
</script>

<template>
    <PaginationEllipsis v-bind="delegatedProps" :class="cn('flex h-9 w-9 items-center justify-center', props.class)">
        <slot>
            <MoreHorizontal />
        </slot>
    </PaginationEllipsis>
</template>
